import { OperationContext } from "../OperationContext";
import { Operation } from "./Operation";
import { findWalterCustomXmlPart } from "./SetValueInCustomXmlStore";

export default class GetValueFromCustomXmlStore<T> implements Operation<T | undefined> {
  constructor(public key: string, public defaultValue?: T) {}

  merge(other: Operation<unknown>): Operation<T> | undefined {
    if (other instanceof GetValueFromCustomXmlStore && other.key === this.key) {
      return other as unknown as Operation<T>;
    }
  }

  async commit(context: OperationContext) {
    const partAndDocument = await findWalterCustomXmlPart(context);

    if (partAndDocument) {
      const customXmlStore = partAndDocument.customXmlStore;
      const propertyValue = customXmlStore.getProperty(this.key) as T;

      return propertyValue ?? this.defaultValue;
    } else {
      return this.defaultValue;
    }
  }
}
